import { ticketInstance } from './ticketInstance';

interface VerificationRequest {
  eventId: number;
  phoneNumber: string;
}

interface CheckCodeRequest {
  phoneNumber: string;
  code: string;
}

interface SMSProcessingRequest {
  to: string;
  message: string;
}

interface TicketApplyRequest {
  eventId: number;
  phoneNumber: string;
  ticketCount: number;
}

export interface GuestTicket {
  phoneNumber: string;
  reservationNumber: string;
  eventName: string;
  count: number;
  canceled: boolean;
}

// 전화번호 인증 코드 전송
export const sendVerificationCode = (data: VerificationRequest) => {
  return ticketInstance.post('/api/verification/send/code', data);
};

// 인증 코드 확인
export const checkVerificationCode = (data: CheckCodeRequest) => {
  return ticketInstance.post('/api/verification/check/code', data);
};

// 문자 발송 처리 시간 체크
export const sendSMSProcessingTime = (data: SMSProcessingRequest) => {
  return ticketInstance.post('/api/sms/processingTime', data);
};

// 티켓 신청
export const applyTicket = (data: TicketApplyRequest) => {
  return ticketInstance.post('/api/ticket/apply', data);
};

// 티켓팅 정보 조회
export const getTicketingInfo = (id: number) => {
  return ticketInstance.get(`/api/event`, { params: { id } });
};

// 티켓팅 오픈 여부 조회
export const checkTicketingOpen = (id: number) => {
  return ticketInstance.get(`/api/event/isOpen`, { params: { id } });
};

// 티켓팅 취소
export const getGuestTickets = async (
  festivalId: number,
): Promise<GuestTicket[]> => {
  const token = sessionStorage.getItem('guestToken');
  if (!token) throw new Error('인증 토큰이 없습니다.');

  const response = await ticketInstance.get<GuestTicket[]>(
    '/api/guest/tickets',
    {
      headers: {
        'X-Guest-Token': token,
      },
      params: {
        festivalId,
      },
    },
  );

  return response.data;
};

export const cancelGuestTicket = async (reservationNumber: string) => {
  const token = sessionStorage.getItem('guestToken');
  if (!token) throw new Error('인증 토큰이 없습니다.');

  return ticketInstance.delete(`/api/guest/tickets/${reservationNumber}`, {
    headers: {
      'X-Guest-Token': token,
    },
  });
};
